import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import IconButton from "@mui/material/IconButton";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: 5,
        },
      },
    },
  },
});
export default function MSelect(props) {
  return (
    <ThemeProvider theme={theme}>
      <table width="100%">
        <tbody>
          <tr>
            <td>
              <Autocomplete
                style={props.style}
                id={props.id}
                options={props.options}
                getOptionLabel={(option) => {
                  return option ? option.name : "";
                }}
                disabled={props.disabled}
                value={props.value}
                onChange={(event, newValue) => {
                  if (props.onChange) props.onChange(event, newValue);
                }}
                disableClearable
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size={props.size}
                    label={props.label}
                    error={
                      (props.errorMessage && props.errorMessage.length) > 0
                        ? true
                        : false
                    }
                    helperText={props.errorMessage}
                    onFocus={(e) => {
                      if (props.onFocus) props.onFocus(e);
                    }}
                    onBlur={(e) => {
                      if (props.onBlur) props.onBlur(e);
                    }}
                  />
                )}
              />
            </td>
            {props.onClearFilter && (
              <td width="5%">
                <IconButton
                  color="inherit"
                  aria-label="more"
                  onClick={props.onClearFilter}
                >
                  <CachedOutlinedIcon />
                </IconButton>
              </td>
            )}
          </tr>
        </tbody>
      </table>
    </ThemeProvider>
  );
}
